export class Customerstrainer {
    _id: string;
    trainerId: string;
    name: string
    totalFees: string;
    gymShare:string;
    trainerShare:string;
    description:string;
    sessionCount:string;
    remainingSessionCount:number;
    dueDate: Date; 
}